export default __webpack_public_path__ + "static/media/sterling.28aadcc0.svg";